import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ViewMode } from "src/app/shared/enums/view-mode.enum";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionReport } from "../shared/models/report.permission.model";
import { PermissionsServiceService } from "../shared/services/permissions-service.service";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";
import {
  getViewModleForPermissions,
  setSelectAllReportStatus,
} from "./permissions-reports.mapper";

@Component({
  selector: "app-permissions-reports",
  templateUrl: "./permissions-reports.component.html",
  styleUrls: ["./permissions-reports.component.scss"],
})
export class PermissionsReportsComponent implements OnInit {
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  private _allPermissionInCategory: { data: any[]; groupPermission: number[] } =
    { data: [], groupPermission: [] };
  @Input() set allPermissionsInCategory(value: {
    data: any[];
    groupPermission: number[];
  }) {
    this._allPermissionInCategory = value;
    this.updatModlesFromBackEnd(this._allPermissionInCategory?.data ?? []);
  }
  isLoaded: boolean = false;

  @Output() ReportObject: EventEmitter<PermissionReport> =
    new EventEmitter<PermissionReport>();
  public permissionReport: PermissionReport = new PermissionReport();
  public initialPermissionReportState: PermissionReport =
    new PermissionReport();
  @Input() isViewOnly: boolean = false;
  @Input() isUkgDefaultGroup: boolean = false;
  @Output() sectionSelectAll: EventEmitter<boolean> = new EventEmitter<boolean>(
    false
  );
  public disabledSelectAllReports: boolean = true;

  constructor(
    public permissionService: PermissionsServiceService,
    private translationLoaderFacade: TranslationLoaderFacade
  ) {}

  ngOnInit(): void {
  }
  ngOnDestroy() {
    this.permissionReport = new PermissionReport();
  }

  private updatModlesFromBackEnd(model: SinglePermissionModel[]) {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEditting) => {
        if (isEditting) {
          this.setedditingParams(model, isEditting.viewMode);
        } else {
          this.setAddParams(model);
        }
        this.initialPermissionReportState = JSON.parse(
          JSON.stringify(this.permissionReport)
        );
        this.publishUpdatedObject(false);
      });
  }

  checkSelectAllPermission(isSelectAllEnabled: boolean) {
    if (isSelectAllEnabled) {
      this.changeSelectAllReport();
    } else {
      this.permissionReport.selectAllPermissionReport.Selected = false;
      this.sectionSelectAll.emit(false);
    }
  }

  onLobbyActivityItemChange(): void {
    this.permissionReport.LobbyActivity.selectAll =
      this.permissionReport.LobbyActivity.viewLobbyActivity.Selected &&
      this.permissionReport.LobbyActivity.shareTemplateLobbyActivity.Selected &&
      this.permissionReport.LobbyActivity.deleteTemplateLobbyActivity
        .Selected &&
      this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected;
    this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected =
      this.permissionReport.LobbyActivity.viewLobbyActivity.Selected &&
      this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected;
    this.changeSelectAllReport();
    this.handleLobbyActivityChildElements();
    this.publishUpdatedObject();
  }
  handleLobbyActivityChildElements() {
    const lobbyActivity = this.permissionReport.LobbyActivity;
    if (!lobbyActivity.viewLobbyActivity.Selected) {
      lobbyActivity.shareTemplateLobbyActivity.Selected = false;
      lobbyActivity.deleteTemplateLobbyActivity.Selected = false;
      lobbyActivity.viewStaffSignInOutReport.Selected = false;
    }
  }
  selectAllLobbyActivity(): void {
    this.permissionReport.LobbyActivity.viewLobbyActivity.Selected =
      this.permissionReport.LobbyActivity.viewLobbyActivity.Selected &&
      !this.permissionReport.LobbyActivity.viewLobbyActivity.Enabled
        ? true
        : this.permissionReport.LobbyActivity.selectAll &&
          this.permissionReport.LobbyActivity.viewLobbyActivity.Enabled;
    this.permissionReport.LobbyActivity.shareTemplateLobbyActivity.Selected =
      this.permissionReport.LobbyActivity.shareTemplateLobbyActivity.Selected &&
      !this.permissionReport.LobbyActivity.shareTemplateLobbyActivity.Enabled
        ? true
        : this.permissionReport.LobbyActivity.selectAll &&
          this.permissionReport.LobbyActivity.shareTemplateLobbyActivity
            .Enabled;
    this.permissionReport.LobbyActivity.deleteTemplateLobbyActivity.Selected =
      this.permissionReport.LobbyActivity.deleteTemplateLobbyActivity
        .Selected &&
      !this.permissionReport.LobbyActivity.deleteTemplateLobbyActivity.Enabled
        ? true
        : this.permissionReport.LobbyActivity.selectAll &&
          this.permissionReport.LobbyActivity.deleteTemplateLobbyActivity
            .Enabled;
    this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected =
      this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected &&
      !this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Enabled
        ? true
        : this.permissionReport.LobbyActivity.selectAll &&
          this.permissionReport.LobbyActivity.viewStaffSignInOutReport.Enabled;
    this.checkSelectAllPermission(
      this.permissionReport.LobbyActivity.selectAll
    );
    this.publishUpdatedObject();
  }

  onLobbyEditItemChange(): void {
    this.permissionReport.LobbyEdit.selectAll =
      this.permissionReport.LobbyEdit.viewLobbyEditReports.Selected &&
      this.permissionReport.LobbyEdit.editLobbyEditReports.Selected &&
      this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Selected &&
      this.permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Selected;
    this.changeSelectAllReport();
    this.handleLobbyEditChildElements();
    this.publishUpdatedObject();
  }
  handleLobbyEditChildElements() {
    const lobbyEditor = this.permissionReport.LobbyEdit;
    if (!lobbyEditor.viewLobbyEditReports.Selected) {
      lobbyEditor.editLobbyEditReports.Selected = false;
      lobbyEditor.shareTemplateLobbyEditReports.Selected = false;
      lobbyEditor.deleteTemplateLobbyEditReports.Selected = false;
    }
  }
  selectAllLobbyEdit() {
    this.permissionReport.LobbyEdit.viewLobbyEditReports.Selected =
      this.permissionReport.LobbyEdit.viewLobbyEditReports.Selected &&
      !this.permissionReport.LobbyEdit.viewLobbyEditReports.Enabled
        ? true
        : this.permissionReport.LobbyEdit.selectAll &&
          this.permissionReport.LobbyEdit.viewLobbyEditReports.Enabled;
    this.permissionReport.LobbyEdit.editLobbyEditReports.Selected =
      this.permissionReport.LobbyEdit.editLobbyEditReports.Selected &&
      !this.permissionReport.LobbyEdit.editLobbyEditReports.Enabled
        ? true
        : this.permissionReport.LobbyEdit.selectAll &&
          this.permissionReport.LobbyEdit.editLobbyEditReports.Enabled;
    this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Selected =
      this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Selected &&
      !this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Enabled
        ? true
        : this.permissionReport.LobbyEdit.selectAll &&
          this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Enabled;
    this.permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Selected =
      this.permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Selected &&
      !this.permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Enabled
        ? true
        : this.permissionReport.LobbyEdit.selectAll &&
          this.permissionReport.LobbyEdit.deleteTemplateLobbyEditReports
            .Enabled;
    this.checkSelectAllPermission(this.permissionReport.LobbyEdit.selectAll);
    this.publishUpdatedObject();
  }

  publishUpdatedObject(emitDirty: boolean = true): void {
    if (
      emitDirty &&
      JSON.stringify(this.permissionReport) !==
        JSON.stringify(this.initialPermissionReportState)
    ) {
      this.dirtyEmitter.emit(true);
    } else {
      this.dirtyEmitter.emit(false);
    }
    this.ReportObject.emit(this.permissionReport);
  }

  setedditingParams(model: SinglePermissionModel[], viewMode: number) {
    this.permissionReport = getViewModleForPermissions(
      model,
      viewMode,
      this._allPermissionInCategory.groupPermission
    );
    //this.permissionReport = getViewModleForPermissions(model, true, viewMode);
    this.disabledSelectAllReports = setSelectAllReportStatus(
      this.permissionReport
    );
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  setAddParams(model: SinglePermissionModel[]) {
    this.permissionReport = getViewModleForPermissions(model, ViewMode.Add);
    this.disabledSelectAllReports = setSelectAllReportStatus(
      this.permissionReport
    );
    //this.permissionReport = getViewModleForPermissions(model,false);
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  valueChangeByselectAllPermissionsReport(e: Event) {
    const target = e.target as HTMLInputElement;
    this.valueChangeByselectAllPermissionsReportCommon(target.checked);
    this.sectionSelectAll.emit(target.checked);
  }

  valueChangeByselectAllPermissionsReportCommon(isEnable: boolean) {
    if (
      this.permissionReport.LobbyActivity.viewLobbyActivity.Enabled &&
      this.permissionReport.LobbyActivity.shareTemplateLobbyActivity.Enabled
    )
      this.permissionReport.LobbyActivity.selectAll = isEnable;

    if (
      this.permissionReport.LobbyEdit.editLobbyEditReports.Enabled &&
      this.permissionReport.LobbyEdit.viewLobbyEditReports.Enabled &&
      this.permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Enabled
    )
      this.permissionReport.LobbyEdit.selectAll = isEnable;

    this.selectAllLobbyActivity();
    this.selectAllLobbyEdit();
  }

  changeSelectAllReport() {
    this.permissionReport.selectAllPermissionReport.Selected =
      this.permissionReport.LobbyActivity.selectAll == true &&
      this.permissionReport.LobbyEdit.selectAll == true;
    this.sectionSelectAll.emit(
      this.permissionReport.selectAllPermissionReport.Selected
    );
  }
}
